const envs = [
    {
        name: 'host',
        originalName: 'VUE_APP_API_HOST',
        default: 'http://127.0.0.1:8000'
    },
    {
        name: 'name',
        originalName: 'VUE_APP_NAME',
        default: 'CAPP MastersClub'
    },
    {
        name: 'password-length',
        originalName: 'VUE_APP_PASSWORD_LENGTH',
        default: '8'
    },
    {
        name: 'dashboard-transaction-limit',
        originalName: 'VUE_APP_DASHBOARD_TRANSACTIONS_LIMIT',
        default: '5'
    },
    {
        name: 'dashboard-news-limit',
        originalName: 'VUE_APP_DASHBOARD_NEWS_LIMIT',
        default: '3'
    },
    {
        name: 'dashboard-wishlist-limit',
        originalName: 'VUE_APP_DASHBOARD_WISHLIST_LIMIT',
        default: '6'
    },
    // Firebase
    {
        name: 'firebase-api-key',
        originalName: 'VUE_APP_FIREBASE_API_KEY',
        default: null
    },
    {
        name: 'firebase-auth-domain',
        originalName: 'VUE_APP_FIREBASE_AUTH_DOMAIN',
        default: null
    },
    {
        name: 'firebase-database-url',
        originalName: 'VUE_APP_FIREBASE_DATABASE_URL',
        default: null
    },
    {
        name: 'firebase-project-id',
        originalName: 'VUE_APP_FIREBASE_PROJECT_ID',
        default: null
    },
    {
        name: 'firebase-storage-bucket',
        originalName: 'VUE_APP_FIREBASE_STORAGE_BUCKET',
        default: null
    },
    {
        name: 'firebase-messaging-sender-id',
        originalName: 'VUE_APP_FIREBASE_MESSAGING_SENDER_ID',
        default: null
    },
    {
        name: 'firebase-app-id',
        originalName: 'VUE_APP_FIREBASE_APP_ID',
        default: null
    },
    {
        name: 'firebase-measurement-id',
        originalName: 'VUE_APP_FIREBASE_MEASUREMENT_ID',
        default: null
    },
    {
        name: 'firebase-vapid-key',
        originalName: 'VUE_APP_FIREBASE_VAPID_KEY',
        default: null
    },
    {
        name: 'data-invalidation',
        originalName: 'VUE_APP_DATA_INVALIDATION',
        default: null
    },
    {
        name: 'dynamic-api',
        originalName: 'VUE_APP_DYNAMIC_API',
        default: false
    },
    {
        name: 'appstore-link',
        originalName: 'VUE_APP_APPSTORE_LINK',
        default: null
    },
    {
        name: 'playstore-link',
        originalName: 'VUE_APP_PLAYSTORE_LINK',
        default: null
    },
    {
        name: 'sentry',
        originalName: 'VUE_APP_SENTRY',
        default: null
    }
];

export default name => {
    const usedEnvFile =
        process.env.NODE_ENV === 'production'
            ? '.env.production'
            : '.env.local';

    const envByName = envs.find(env => env.name === name);

    if (!envByName) {
        console.warn(`no env called "${name}" available`);
        return;
    }

    if (!process.env[envByName.originalName]) {
        console.warn(
            `the env variable "${envByName.originalName}" is missing on your ${usedEnvFile} file.\n\nthe following default value will be used: ${envByName.default}`
        );
        return envByName.default;
    }

    return process.env[envByName.originalName];
};
